<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="1024">
  <kendo-dialog-titlebar>
    <h3>{{ (isNew ? 'ADD-FIELD-CONFIGURATION' : 'EDIT-FIELD-CONFIGURATION') | translate }}</h3>
  </kendo-dialog-titlebar>
  <form novalidate [formGroup]="editForm">
    <kendo-tabstrip #tabstrip>
      <kendo-tabstrip-tab title="{{ 'FIELD-CONFIGURATION-TAB-FIELD' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <div class="pt-3 pl-3 pr-3">
            <div class="form-group">
              <label for="name" class="control-label k-text-uppercase dark">{{ 'NAME' | translate }} *</label>
              <input kendoTextBox class="kendo-text-width w-100" formControlName="name" maxlength="50" />
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="name.hasError('required') && name.touched">
                {{ 'REQUIRED-NAME' | translate }}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('nameExists')">
                {{'FIELD-CONFIGURATION-ALREADY-EXISTS' | translate}}
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-6">
                <label for="type" class="control-label k-text-uppercase dark">{{ 'FIELD-TYPE' | translate }} *</label>
                <kendo-combobox class="w-100" formControlName="type" [data]="listFieldTypes" [textField]="'text'"
                  [valueField]="'value'" [valuePrimitive]="true">
                </kendo-combobox>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="type.hasError('required') && type.touched">
                  {{ 'REQUIRED-FIELD-TYPE' | translate }}
                </div>
              </div>
              <div class="col-sm-6" *ngIf="editForm.controls.type.value === 'Category'">
                <label for="codeSet" class="control-label k-text-uppercase dark">{{ 'CODE-SET' | translate }}</label>
                <kendo-combobox class="w-100" formControlName="codeSet" [data]="codeSets" [textField]="'name'"
                  [valueField]="'id'" [valuePrimitive]="false">
                </kendo-combobox>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-6">
                <label for="type" class="control-label k-text-uppercase dark">{{ 'FIELD-MAIN-SECTION' | translate }}
                  *</label>
                <kendo-combobox class="w-100" formControlName="section" [data]="mainSections" [textField]="'text'"
                  [valueField]="'value'" [valuePrimitive]="true">
                </kendo-combobox>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="section.hasError('required') && section.touched">
                  {{ 'REQUIRED-FIELD-MAIN-SECTION' | translate }}
                </div>
              </div>
              <div class="col-sm-6" *ngIf="editForm.controls.section.value === 'ClinicalHistory'">
                <label for="type" class="control-label k-text-uppercase dark w-100">{{ 'FIELD-SUB-SECTION' | translate
                  }} *
                </label>
                <kendo-combobox class="w-100" formControlName="subSection" [data]="subSections" [textField]="'text'"
                  [valueField]="'value'" [valuePrimitive]="true">
                </kendo-combobox>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="subSection.hasError('required') && subSection.touched">
                  {{ 'REQUIRED-FIELD-SUB-SECTION' | translate }}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="xpath" class="control-label k-text-uppercase dark">{{ 'XPATH' | translate }} *</label>
              <textarea kendoTextArea class="w-100 container-options" cols="120" rows="4" formControlName="xpath"
                maxlength="1000"></textarea>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="xpath.hasError('required') && xpath.touched">
                {{ 'REQUIRED-XPATH' | translate }}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="xpath.hasError('missingOperator') && xpath.touched">
                {{ 'FIELD-CONFIGURATION-MISSING-$OPERATOR' | translate }}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="xpath.hasError('missingValue') && xpath.touched">
                {{ 'FIELD-CONFIGURATION-MISSING-$VALUE' | translate }}
              </div>
            </div>
            <div class="form-group">
              <label class="control-label k-text-uppercase dark mr-2" style="min-width:auto;" for="active">{{ 'ENABLED'
                | translate }}</label>
              <kendo-switch formControlName="active" onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}">
              </kendo-switch>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab [disabled]="editForm.controls.type.value !== 'Category' || editForm.controls.codeSet.value"
        title="{{ 'FIELD-CONFIGURATION-TAB-VALUES' | translate }}">
        <ng-template kendoTabContent>
          <div class="p-3">
            <button kendoButton [primary]="true" (click)="addOption()" type="button" class="mb-2">
              {{'ADD-VALUE' | translate}}<i class="far fa-plus"></i>
            </button>
            <div class="k-tooltip k-tooltip-validation" role="alert" [hidden]="hiddenOptionRequired">{{ 'NO-VALUE' |
              translate }}
            </div>
            <div formArrayName="options" class="container-options">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>
                      <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'NAME' | translate }}
                        *</label>
                    </th>
                    <th>
                      <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'VALUE' | translate }}
                        *</label>
                    </th>
                    <th>
                      <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'CODE-SET' | translate
                        }}</label>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let option of editForm.controls.options.controls; let i=index" [formGroupName]="i">
                    <td style="width:35%">
                      <input kendoTextBox formControlName="name" class="w-100" maxlength="256" />
                      <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.options.controls[i].controls.name.hasError('required') && 
                                                editForm.controls.options.controls[i].controls.name.touched">
                        {{ 'REQUIRED-NAME' | translate }}
                      </div>
                    </td>
                    <td style="width:35%">
                      <input kendoTextBox formControlName="value" class="w-100" maxlength="100"
                        *ngIf="isValueVisible(i)" />
                      <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.options.controls[i].controls.value.hasError('required') &&
                                                editForm.controls.options.controls[i].controls.value.touched">
                        {{ 'REQUIRED-FIELD-VALUE' | translate }}
                      </div>
                    </td>
                    <td style="width:40%">
                      <kendo-combobox class="w-100" formControlName="codeSet" [data]="codeSets" [textField]="'name'"
                        [valueField]="'id'" [valuePrimitive]="false">
                      </kendo-combobox>
                    </td>
                    <td>
                      <a title="{{ 'DELETE' | translate }}"
                        (click)="removeOption(i,editForm.controls.options.controls[i].controls.id.value, editForm.controls.options.controls[i].controls.value.value)">
                        <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
    <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
  </form>
  <kendo-dialog-actions>
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <!--!editForm.valid || !editForm.dirty-->
    <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
      (click)="onSave($event)">{{
      'SAVE' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>